module.exports = __webpack_public_path__ + "img/menu.086d2bcc.svg";